import { useEffect as e } from "react";
import { updateLinkColors as f } from "./index.mjs";
const o = (t, r) => {
  e(() => {
    t && r && f(t, r);
  }, [r]);
};
export {
  o as useUpdateLinkColor
};
